module.exports = __webpack_public_path__ + "static/media/SmartShop_8-528w.d45dc01f.png";